export function parseLocationData(data) {
  const countries = data
    .filter(item => item.name)
    .map(item => ({
      value: item.name,
      label: item.name,
    }));

  const citiesByCountry = {};
  data.forEach(item => {
    if (item.name && item.cities) {
      citiesByCountry[item.name] = item.cities.map(city => ({
        value: city,
        label: city,
      }));
    }
  });

  return { countries, citiesByCountry };
}